  <template>
<div class="background">
<div class="content container" v-anime="{opacity: 1, loop: false, duration: 5000 }">
<div class="row"> 
  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <a href="https://youtu.be/LtveBr2VFh0" title="Robot aim"><img src="../assets/aim.png"  class="rounded" alt="Robot aim"></a>
    <a href="https://youtu.be/x1nRjxcXjL0" title="Robot catch"><img src="../assets/catch.png"  class="rounded" alt="Robot catch"></a>
    <a href="https://github.com/SundayLab/robot_ddpg" title="Keras ddpg agent"><img href="https://www.youtube.com/watch?v=pkbLhoejpk8" src="../assets/ddpg_3.png"  class="rounded" alt="Keras ddpg agent"></a>
    <a href="https://www.youtube.com/watch?v=pkbLhoejpk8" title="Unity3D machine learning"><img href="https://www.youtube.com/watch?v=pkbLhoejpk8" src="../assets/robot_env.png"  class="rounded" alt="Robot Env"></a>
    <a href="https://www.youtube.com/watch?v=Wlksv1McBoo" title="Mobilenet ssd"><img src="../assets/mobilenet.png"  class="rounded" alt="Mobilenet ssd"></a>
    <a href="https://github.com/SundayLab/robot_platform" title="Robot platform"><img class="rounded" src="../assets/robot_platform.png"  alt="Robot Platform"></a>
    <a href="https://github.com/SundayLab/robot_dqn" title="Robot DQN"><img src="../assets/robot_dqn.png"  class="rounded" alt="Robot DQN"></a>
    <a href="https://www.youtube.com/watch?v=boiT3oLpwqY" title="Keras machine learning"><img src="../assets/machine.png"  class="rounded" alt="Keras machine learning"></a>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <a href="https://youtu.be/EsCqWPyjzY8" title="Robot follow"><img src="../assets/follow.png"  class="rounded" alt="Robot follow"></a>
    <a href="https://sundaylab.github.io" title="Marblerun"><img src="../assets/marble.png"  class="rounded" alt="Marblerun"></a>
    <a href="https://hackaday.io/project/25159-switchmaster" title="Switchmaster"><img src="../assets/switchmaster.png"  class="rounded" alt="Switchmaster"></a>
    <a href="http://sundaylab.github.io/reinforcement/game.html" title="TicTacToe"><img src="../assets/game.png"  class="rounded" alt="TicTacToe"></a>
    <a href="https://github.com/SundayLab/Camera2BasicStream" title="Android Camera"><img src="../assets/strea.png" class="rounded" alt="Android Camera"></a>
    <a href="http://codepen.io/sundaylab/pen/GqLYjV" title="Sequencer Tembre.js"><img src="../assets/sequencer.png"  class="rounded" alt="Timbre.js Sequencer"></a>
  </div>  
  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <a href="https://youtu.be/EDCaDDKuG-A" title="Robot power"><img src="../assets/power.png"  class="rounded" alt="Robot power"></a>
    <a class="tile" href="https://codepen.io/sundaylab/pen/YNXMqr" title="Three.js cubes"><img src="../assets/cubes.png" class="rounded" alt="Three.js Cubes"></a>
    <a class="tile" href="http://codepen.io/sundaylab/pen/zvdGor" title="Angular and d3.js"><img src="../assets/metricvis.png" class="rounded" alt="Angular and d3.js"></a>
    <a class="tile" href="http://codepen.io/sundaylab/pen/epeVVa" title="Random Color"><img src="../assets/circlevis.png"  class="rounded" alt="Random Color"></a>
    <a href="https://www.youtube.com/channel/UCEipj86zl7pf73f8JNYkU7w/videos" title="Trekkr"><img src="../assets/trekkr.png"  class="rounded" alt="Trekkr"></a>
    <a href="http://codepen.io/sundaylab/pen/meapEo" title="Leaflet waypoint travel"><img src="../assets/map.png"  class="rounded" alt="Leaflet waypoint travel"></a>
  </div>
</div>
</div>
  </div>
</template>

<style lang="scss" scoped>
.md-card {
  min-width: 320px;
  margin: 1px;
  display: inline-block;
  background: transparent;
}

.tile{
    min-width: 320px;

}


.background {
  background-color: transparent;
}

.content{
  display: flex;
  overflow-y: scroll;
  padding-top: 100px;
  align-items: center;
  justify-content: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -ms-flexbox;
  -webkit-box-align: center;
  -webkit-flex-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
}

::-webkit-scrollbar {
    display: none;
}

.card {
  width: 320px;
  margin: 10px 10px 35px 10px;
  display: inline-block;
  background: transparent;
}

.row > div {
      padding: 0 4px !important;
}

.rounded {
    margin: 10px 10px;
    vertical-align: middle;  
}



</style>

<script>
export default {
  name: "Services"
};
</script>

